import { Flex, Text } from '@mantine/core';
import { useNotification } from '@refinedev/core';
import { useEffect } from 'react';
import { IconKeyOff } from '@tabler/icons-react';

export const TokenExpired = () => {
  const { open } = useNotification();

  useEffect(() => {
    open?.({
      message: 'Your session has expired. The page will refresh.',
      type: 'error',
    });
  }, [open]);
  return (
    <Flex
      align="center"
      justify="center"
      direction="column"
      style={{ height: '75vh' }}
      data-testid="token-expired"
    >
      <IconKeyOff size={150} />
      <Text style={{ textAlign: 'center' }} size={'xl'} fw={500} pt={'lg'}>
        Token Expired
      </Text>
      <Text style={{ textAlign: 'center' }} size="lg">
        Your session has expired. The page will refresh.
      </Text>
    </Flex>
  );
};
